import { PassengerArrangement } from '@shared/base-search-bar/entities/passenger-arrangement';

export function calculatePassengerArrangement(
  quantity: number,
  type: PassengerArrangement,
  passengerArrangement: PassengerArrangement[],
  maxPassengers: number
): { updatedArrangement: PassengerArrangement[], adjustedQuantity: number } {
  let newQuantity = quantity;

  const totalOtherPassengers = passengerArrangement
    .filter((p) => p.id !== type.id)
    .reduce((sum, p) => sum + p.quantity, 0);

  const newTotal = totalOtherPassengers + newQuantity;
  if (newTotal > maxPassengers) {
    return { updatedArrangement: passengerArrangement, adjustedQuantity: type.quantity };
  }

  const updatedArrangement = passengerArrangement.map((p) =>
    p.id === type.id
      ? { ...p, quantity: newQuantity }
      : p
  );

  return { updatedArrangement, adjustedQuantity: newQuantity };
}
